/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $UsernameRecovery = {
    properties: {
        operatorId: {
            type: 'string',
            isRequired: true,
            format: 'uuid',
        },
        districtId: {
            type: 'string',
            isRequired: true,
            format: 'uuid',
        },
        accountNumber: {
            type: 'string',
            isRequired: true,
            minLength: 1,
        },
    },
};